var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3667 16.4329C11.3667 15.4308 11.6639 14.4512 12.2206 13.618C12.7773 12.7848 13.5686 12.1354 14.4944 11.7519C15.4203 11.3684 16.439 11.2681 17.4218 11.4636C18.4047 11.6591 19.3075 12.1416 20.0161 12.8502C20.7246 13.5588 21.2072 14.4616 21.4027 15.4444C21.5982 16.4273 21.4979 17.446 21.1144 18.3718C20.7309 19.2976 20.0815 20.0889 19.2483 20.6457C18.4151 21.2024 17.4355 21.4996 16.4334 21.4996C15.0896 21.4996 13.8009 20.9657 12.8507 20.0156C11.9005 19.0654 11.3667 17.7767 11.3667 16.4329Z",
    stroke: "#2D2D2A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4333 18.9671V13.9004",
    stroke: "#2D2D2A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4334 13.9004L14.5334 15.8004",
    stroke: "#2D2D2A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4333 13.9004L18.3334 15.8004",
    stroke: "#2D2D2A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.83334 17.6998H3.76667C3.43073 17.6998 3.10854 17.5664 2.871 17.3288C2.63345 17.0913 2.5 16.7691 2.5 16.4331V7.56647C2.5 7.23053 2.63345 6.90835 2.871 6.6708C3.10854 6.43326 3.43073 6.2998 3.76667 6.2998H16.4333C16.7693 6.2998 17.0915 6.43326 17.329 6.6708C17.5666 6.90835 17.7 7.23053 17.7 7.56647V8.83314",
    stroke: "#2D2D2A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2913 6.63525L14.9091 3.06409C14.7937 2.89094 14.6374 2.74889 14.454 2.65051C14.2706 2.55212 14.0659 2.50043 13.8578 2.5H6.34221C6.13368 2.50002 5.92839 2.55151 5.74455 2.64991C5.56071 2.74832 5.404 2.89058 5.28834 3.06409L2.90869 6.63525",
    stroke: "#2D2D2A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0999 2.5V6.3",
    stroke: "#2D2D2A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.512dfea76ce2ca456750878fe9e42025.svg";
export { ForwardRef as ReactComponent };